import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    IClientFormFilters,
    IConsentActionPayload,
    IConsentDraftPayload,
    IConsentFormFilters,
} from "../types/client-forms.types";

export async function getClientForms(filters: IClientFormFilters) {
    const response = await axios.get("/forms", {
        params: handleRemoveEmptyParamFromQueryParams(filters),
    });
    return response.data;
}

export async function getClientConsents(filters?: IConsentFormFilters) {
    const response = await axios.get("/consents", {
        params: filters
            ? handleRemoveEmptyParamFromQueryParams(filters)
            : undefined,
    });
    return response.data;
}

export async function getConsentByBookingId(bookingId: string) {
    const response = await axios.get(`/consent/${bookingId}`);
    return response.data;
}

export async function saveConsentDraft(
    consentId: string,
    data: IConsentDraftPayload
) {
    const response = await axios.patch(`/consent/${consentId}/draft`, data);
    return response.data;
}

export async function fetchFormDocument(fileUrl: string) {
    const response = await axios.get("/forms/file", {
        params: { file_url: fileUrl },
    });
    return response.data;
}

export async function recordConsentAction(
    bookingId: string,
    data: IConsentActionPayload
) {
    const response = await axios.post(`/consent/${bookingId}/action`, data);
    return response.data;
}

export async function uploadConsentAttachments(
    consentId: string,
    fieldId: string,
    files: File[]
) {
    const formData = new FormData();
    formData.append("field_id", fieldId);
    files.forEach((file) => formData.append("document", file));
    const response = await axios.post(
        `/consent/${consentId}/attachment`,
        formData
    );
    return response.data;
}
